import { gql } from '@apollo/client';
import { Suggestion } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const SendSuggestionEmail = () => gql`
  mutation suggestionEmail($params: SuggestionEmailParams!) {
    suggestionEmail(params: $params)
  }
`;

export type SuggestionEmailParams = ResolverParams<{
  name: string;
  email: string;
  comment: string;
  origin: Suggestion['origin'];
}>;

export type SuggestionEmailResponse = void;
